"use strict";

exports.__esModule = true;
exports.KaruraAdaptor = exports.BaseAcalaAdaptor = exports.AcalaAdaptor = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _rxjs = require("rxjs");
var _chains = require("../configs/chains");
var _baseChainAdapter = require("../base-chain-adapter");
var _isChainEqual = require("../utils/is-chain-equal");
const crossChainFeeConfigs = {
  KSM: '64000000',
  DOT: '64000000'
};
class BaseAcalaAdaptor extends _baseChainAdapter.BaseCrossChainAdapter {
  constructor(configs, chain, routers) {
    super(configs.api, chain, routers);
    this.wallet = void 0;
    const {
      wallet
    } = configs;
    this.wallet = wallet;
  }
  subscribeMinInput(token) {
    return this.wallet.subscribeToken(token).pipe((0, _rxjs.map)(r => {
      var _this$getCrossChainFe;
      return r.ed.add(((_this$getCrossChainFe = this.getCrossChainFee(token)) === null || _this$getCrossChainFe === void 0 ? void 0 : _this$getCrossChainFe.balance) || _sdkCore.FixedPointNumber.ZERO);
    }));
  }
  subscribeAvailableBalance(token, address) {
    return this.wallet.subscribeBalance(token, address).pipe((0, _rxjs.map)(r => r.available));
  }
  subscribeMaxInput(token, address, to) {
    const {
      nativeToken
    } = this.wallet.getPresetTokens();
    return (0, _rxjs.combineLatest)({
      txFee: this.measureTransferFee({
        amount: _sdkCore.FixedPointNumber.ZERO,
        to,
        token,
        address
      }),
      balance: this.wallet.subscribeBalance(token, address).pipe((0, _rxjs.map)(i => i.available))
    }).pipe((0, _rxjs.map)(_ref => {
      let {
        txFee,
        balance
      } = _ref;
      const feeFactor = 1.2;
      const fee = _sdkCore.FixedPointNumber.fromInner(txFee, nativeToken.decimals || 12).mul(new _sdkCore.FixedPointNumber(feeFactor));
      return balance.minus(fee);
    }));
  }
  getCrossChainFee(token) {
    var _crossChainFeeConfigs;
    return {
      token,
      balance: _sdkCore.FixedPointNumber.fromInner((_crossChainFeeConfigs = crossChainFeeConfigs[token]) !== null && _crossChainFeeConfigs !== void 0 ? _crossChainFeeConfigs : '0', this.wallet.getToken(token).decimals)
    };
  }
  getCrossChainTokenDecimals(token) {
    return this.wallet.getToken(token).decimals;
  }

  // all token's destination weight in karura/acala is same
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getDestinationWeight(_token) {
    return 5 * 1000000000;
  }
  createTx(params) {
    const {
      to,
      token,
      address,
      amount
    } = params;
    const tokenFormSDK = this.wallet.getToken(token);
    const accountId = this.api.createType('AccountId32', address).toHex();
    const toChain = _chains.chains[to];
    if ((0, _isChainEqual.isChainEqual)(toChain, 'statemine')) {
      var _tokenFormSDK$locatio, _tokenFormSDK$locatio2;
      const call = this.api.tx.polkadotXcm.limitedReserveTransferAssets;
      const dst = {
        X2: ['Parent', {
          ParaChain: toChain.paraChainId
        }]
      };
      const acc = {
        X1: {
          AccountId32: {
            id: accountId,
            network: 'Any'
          }
        }
      };
      const ass = [{
        ConcreteFungible: {
          id: {
            X2: [{
              PalletInstance: (_tokenFormSDK$locatio = tokenFormSDK.locations) === null || _tokenFormSDK$locatio === void 0 ? void 0 : _tokenFormSDK$locatio.palletInstance
            }, {
              GeneralIndex: (_tokenFormSDK$locatio2 = tokenFormSDK.locations) === null || _tokenFormSDK$locatio2 === void 0 ? void 0 : _tokenFormSDK$locatio2.generalIndex
            }]
          },
          amount: amount.toChainData()
        }
      }];
      return call({
        V0: dst
      }, {
        V0: acc
      }, {
        V0: ass
      }, 0, 'Unlimited');
    }
    if ((0, _isChainEqual.isChainEqual)(toChain, 'kusama') || (0, _isChainEqual.isChainEqual)(toChain, 'polkadot')) {
      const call = this.api.tx.xTokens.transfer;
      const dst = {
        interior: {
          X1: {
            AccountId32: {
              id: accountId,
              network: 'Any'
            }
          }
        },
        parents: 1
      };
      return call(tokenFormSDK.toChainData(), amount.toChainData(), {
        V1: dst
      }, this.getDestinationWeight(token));
    }

    // if destination is not statemine/kusama
    const call = this.api.tx.xTokens.transfer;
    const dst = {
      parents: 1,
      interior: {
        X2: [{
          Parachain: toChain.paraChainId
        }, {
          AccountId32: {
            id: accountId,
            network: 'Any'
          }
        }]
      }
    };
    return call(tokenFormSDK.toChainData(), amount.toChainData(), {
      V1: dst
    }, this.getDestinationWeight(token));
  }
}
exports.BaseAcalaAdaptor = BaseAcalaAdaptor;
class AcalaAdaptor extends BaseAcalaAdaptor {
  constructor(configs) {
    super(configs, _chains.chains.acala, [
    // polkadot
    {
      to: _chains.chains.polkadot,
      token: 'DOT'
    }]);
  }
}
exports.AcalaAdaptor = AcalaAdaptor;
class KaruraAdaptor extends BaseAcalaAdaptor {
  constructor(configs) {
    super(configs, _chains.chains.karura, [
    // kusama
    {
      to: _chains.chains.kusama,
      token: 'KSM'
    },
    // bifrost
    {
      to: _chains.chains.bifrost,
      token: 'KSM'
    }, {
      to: _chains.chains.bifrost,
      token: 'KAR'
    }, {
      to: _chains.chains.bifrost,
      token: 'KUSD'
    }, {
      to: _chains.chains.bifrost,
      token: 'BNC'
    }, {
      to: _chains.chains.bifrost,
      token: 'VSKSM'
    },
    // statemine
    {
      to: _chains.chains.statemine,
      token: 'RMRK'
    }, {
      to: _chains.chains.statemine,
      token: 'ARIS'
    },
    // quartz
    {
      to: _chains.chains.quartz,
      token: 'QTZ'
    },
    // kintsugi
    {
      to: _chains.chains.kintsugi,
      token: 'KINT'
    },
    // khala
    {
      to: _chains.chains.khala,
      token: 'KAR'
    }, {
      to: _chains.chains.khala,
      token: 'KUSD'
    }, {
      to: _chains.chains.khala,
      token: 'PHA'
    }]);
  }
}
exports.KaruraAdaptor = KaruraAdaptor;